import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MesFichesPage from './pages/MesFichesPage';
import NouvelleFichePage from './pages/NouvelleFichePage';
import FicheDetailPage from './pages/FicheDetailPage';
import QuizPage from './pages/QuizPage';
import QuizSolutionPage from './pages/QuizSolutionPage';
import QuizResultsPage from './pages/QuizResultsPage';
import GrandQuizConfigPage from './pages/GrandQuizConfigPage';
import GrandQuizPage from './pages/GrandQuizPage';
import GrandQuizResultsPage from './pages/GrandQuizResultsPage';
import GrandQuizLeaderboardPage from './pages/GrandQuizLeaderboardPage';
import CGUPage from './pages/CGUPage';
import PrivacyPage from './pages/PrivacyPage';
import AccountPage from './pages/AccountPage';
import ContactPage from './pages/ContactPage';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route 
                path="/mes-fiches" 
                element={
                  <ProtectedRoute>
                    <MesFichesPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/nouvelle-fiche" 
                element={
                  <ProtectedRoute>
                    <NouvelleFichePage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/fiche/:id" 
                element={
                  <ProtectedRoute>
                    <FicheDetailPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/quiz/:id" 
                element={
                  <ProtectedRoute>
                    <QuizPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/quiz/:id/solution" 
                element={
                  <ProtectedRoute>
                    <QuizSolutionPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/account/quiz-results" 
                element={
                  <ProtectedRoute>
                    <QuizResultsPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/grand-quiz" 
                element={
                  <ProtectedRoute>
                    <GrandQuizConfigPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/grand-quiz/leaderboard" 
                element={
                  <ProtectedRoute>
                    <GrandQuizLeaderboardPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/grand-quiz/:sessionId" 
                element={
                  <ProtectedRoute>
                    <GrandQuizPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/grand-quiz/:sessionId/results" 
                element={
                  <ProtectedRoute>
                    <GrandQuizResultsPage />
                  </ProtectedRoute>
                } 
              />
              <Route path="/cgu" element={<CGUPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route 
                path="/account" 
                element={
                  <ProtectedRoute>
                    <AccountPage />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;